import React, { ReactNode } from "react";
import Page, { PageProps } from "../../../core/ui/pages/Page";
import {
  Layout,
  Collapse,
  Typography,
  Spin,
  Col,
  Row,
  Space,
  Steps,
  Tooltip
} from "antd";
import OrganisationIndexTag from "../../../organisations/ui/components/OrganisationIndexTag";
import AttachmentTable from "../../../caseLawDocuments/ui/components/AttachmentTable";
import HeadingLabel from "../../../core/ui/components/HeadingLabel";
import { LockFilled } from "@ant-design/icons";
import CaseLawDocumentCourtCaseDescription from "../../../caseLawDocuments/ui/components/CaseLawDocumentCourtCaseDescription";
import { ContentTypes } from "../../../caseLawDocuments/common/Constants";
import { ICaseDecisionDetailsPresenter } from "../../../caseDecisions/presenter/CaseDecisionDetailsPresenter";
import Constants, {
  CaseDecisionStatus
} from "../../../caseDecisions/common/Constants";
const { Title } = Typography;
const { Content } = Layout;
const { Panel } = Collapse;
export interface Props extends PageProps {}

export interface State extends ICaseDecisionDetailsPresenter {}

const renderPanel = (title: string, component: ReactNode) => {
  return (
    <Collapse defaultActiveKey={"0"} key={`details-panel-${title}`}>
      <Panel
        header={
          <span
            style={{
              fontSize: "14px",
              lineHeight: "20px",
              fontWeight: 500
            }}
          >
            {title}
          </span>
        }
        key="0"
      >
        <div style={{ marginLeft: 24 }}>{component}</div>
      </Panel>
    </Collapse>
  );
};
export default class PortalCaseDecisionDetailsPage extends React.Component<
  Props,
  State
> {
  private subscriptionId: number = 0;

  constructor(props: any) {
    super(props);
    this.state = { ...props, current: 0 };
  }

  componentDidMount() {
    this.subscriptionId = this.state.store.subscribe((result) => {
      return this.setState(() => result);
    });
  }

  componentWillUnmount() {
    this.state.store.unsubscribe(this.subscriptionId);
  }
  render() {
    const {
      translate,
      caseDecision,
      attachmentTypes,
      attachmentContentTypes,
      caseDecisionAttachments,
      courtCase,
      indexHierarchyList,
      mainAttachment,
      canEdit,
      removeCaseDecision,
      anonimisedUploadedFile,
      setAnonymisedFileValue,
      showCaseDecisionDetailsPage,
      user
    } = this.state;
    const { Step } = Steps;

    function renderCourtCase() {
      return (
        <div style={{ marginTop: 20 }}>
          <CaseLawDocumentCourtCaseDescription
            courtCase={courtCase}
            translate={translate}
            readonly
            showDecisions
            decisions={
              courtCase?.decisions ? [courtCase?.decisions?.[0]] : undefined
            }
          />
        </div>
      );
    }

    function renderAttachmentContent() {
      return mainAttachment?.contentType?.code ===
        ContentTypes.URL_CONTENT_TYPE ? (
        <Tooltip title={mainAttachment?.content}>
          <a
            href={mainAttachment.content}
            rel="noopener noreferrer"
            target={"_blank"}
          >
            {translate("editors.case_decisions.redirect")}
          </a>
        </Tooltip>
      ) : mainAttachment?.identificationCode !== "Y" &&
        mainAttachment?.attachmentType?.anonymisationRequired ? (
        <a
          href={`/api${Constants.endpointBasePath}/attachments/${mainAttachment?.id}/download`}
        >
          {translate("editors.case_decisions.download")}
        </a>
      ) : (
        <div></div>
      );
    }

    return (
      <Page {...this.props} className={"page-wrapper"}>
        <Spin spinning={this.state.loaders.caseDecisionDetailsLoader}>
          <Layout>
            <Row gutter={[16, 16]}>
              <Col xs={24} sm={24} md={10} xl={5}>
                <Title level={1} style={{ marginBottom: 30 }}>
                  {translate("editors.case_decisions.title")}
                </Title>
              </Col>
              {caseDecision?.status === CaseDecisionStatus.ARCHIVED && (
                <Col xs={24} sm={24} md={14} xl={19}>
                  <Row justify="space-around" align="middle">
                    <Col span={20}>
                      <div className={"png-steps-wrapper"}>
                        <Steps size="small" current={0} className={"png-steps"}>
                          <Step
                            title={translate(
                              "editors.case_decisions.status_values.ARCHIVED"
                            )}
                            className={"png-steps-title"}
                            icon={<LockFilled />}
                          />
                        </Steps>
                      </div>
                    </Col>
                  </Row>
                </Col>
              )}
            </Row>
            <Layout>
              <Layout className={"dashboard-content-wrapper"}>
                <Content className="site-layout-background dashboard-content-container">
                  <Row gutter={[16, 8]} className={"mx-0 mb-4"}>
                    <Space direction="vertical" style={{ width: "100%" }}>
                      {renderPanel(
                        translate("editors.case_decisions.basic_data"),
                        <>
                          <Row>
                            <Col>
                              <HeadingLabel
                                text={translate("editors.case_decisions.name")}
                              />
                              <p>{caseDecision.name}</p>
                            </Col>
                          </Row>
                          {caseDecision.organisationName && (
                            <Row>
                              <Col>
                                <HeadingLabel
                                  text={translate(
                                    "editors.case_decisions.organisation_name"
                                  )}
                                />
                                <p>{caseDecision.organisationName}</p>
                              </Col>
                            </Row>
                          )}
                          {caseDecision.caseDecisionType && (
                            <Row>
                              <Col>
                                <HeadingLabel
                                  text={translate(
                                    "editors.case_decisions.case_decision_type"
                                  )}
                                />
                                <p>{caseDecision.caseDecisionType?.name}</p>
                              </Col>
                            </Row>
                          )}
                          {caseDecision.formattedDate ? (
                            <Row>
                              <Col>
                                <HeadingLabel
                                  text={translate(
                                    "editors.case_decisions.date"
                                  )}
                                />
                                <p>{caseDecision.formattedDate}</p>
                              </Col>
                            </Row>
                          ) : null}
                        </>
                      )}
                      {caseDecision.category && (
                        <Row>
                          <Col>
                            <HeadingLabel
                              text={translate(
                                "editors.case_decisions.case_decision_type"
                              )}
                            />
                            <p>{caseDecision.category}</p>
                          </Col>
                        </Row>
                      )}
                      {renderPanel(
                        translate("editors.case_decisions.court_case.details"),
                        <>
                          <Row>
                            <Col span={24}></Col>
                            <Col span={24}>{renderCourtCase()}</Col>
                          </Row>
                        </>
                      )}
                      {renderPanel(
                        translate("editors.case_decisions.main_attachment"),
                        <>
                          <Row>
                            <Col>
                              <p style={{ marginTop: "1em" }}>
                                {mainAttachment?.name}
                              </p>
                              <p style={{ marginTop: "1em" }}>
                                {mainAttachment?.description}
                              </p>
                              <p style={{ marginTop: "1em" }}>
                                {renderAttachmentContent()}
                              </p>
                            </Col>
                          </Row>
                        </>
                      )}
                      {caseDecisionAttachments.length > 0 &&
                        renderPanel(
                          translate(
                            "editors.case_decisions.additional_attachments"
                          ),
                          <>
                            <AttachmentTable
                              translate={translate}
                              attachmentTypes={attachmentTypes}
                              attachments={caseDecisionAttachments}
                              editable={false}
                              contentTypes={attachmentContentTypes}
                              canDownload={canEdit}
                              item={caseDecision}
                              organisationId={caseDecision.organisationId}
                              basePath={Constants.endpointBasePath}
                              anonimisedUploadedFile={anonimisedUploadedFile}
                              setAnonymisedFileValue={setAnonymisedFileValue}
                            />
                          </>
                        )}
                      {indexHierarchyList.length > 0 &&
                        renderPanel(
                          translate("editors.case_decisions.index_data"),
                          <>
                            {indexHierarchyList.map((indexHierarchy) => (
                              <OrganisationIndexTag
                                indexHierarchyList={indexHierarchy}
                              />
                            ))}
                          </>
                        )}
                    </Space>
                  </Row>
                </Content>
              </Layout>
            </Layout>
          </Layout>
        </Spin>
      </Page>
    );
  }
}
